import { create } from 'zustand'

export const useStore = create((set, get) => ({
  // ─── Auth ─────────────────────────────────────────────
  user: null,
  plan: 'free', // 'free' | 'pro' | 'premium'
  setUser: (user) => set({ user }),
  setPlan: (plan) => set({ plan }),

  // ─── Accounts ─────────────────────────────────────────
  accounts: [],
  setAccounts: (accounts) => set({ accounts }),
  addAccount: (account) => set(s => ({ accounts: [...s.accounts, account] })),

  // ─── Transactions ─────────────────────────────────────
  transactions: [],
  setTransactions: (txns) => set({ transactions: txns }),

  // ─── Budget ───────────────────────────────────────────
  budgets: [],
  setBudgets: (budgets) => set({ budgets }),

  // ─── Portfolio ────────────────────────────────────────
  portfolio: [],
  setPortfolio: (portfolio) => set({ portfolio }),

  // ─── UI ───────────────────────────────────────────────
  sidebarOpen: true,
  toggleSidebar: () => set(s => ({ sidebarOpen: !s.sidebarOpen })),

  // ─── Plan gates ───────────────────────────────────────
  canUseFeature: (feature) => {
    const { plan } = get()
    const gates = {
      ai_coach: ['pro', 'premium'],
      investment_tracking: ['pro', 'premium'],
      unlimited_accounts: ['pro', 'premium'],
      unlimited_ai: ['premium'],
      goal_planning: ['premium'],
      tax_reports: ['premium'],
    }
    return !gates[feature] || gates[feature].includes(plan)
  },
}))
